import {IGalleryStyleParams, IPropsInjectedByViewerScript, IGallerySantaProps} from '../types/galleryTypes';
import {IHostProps} from '@wix/native-components-infra/dist/es/src/types/types';

type ProvidedGlobalPropNames =
  | 'addedToCartSuccessfully'
  | 'clearFilters'
  | 'currentPage'
  | 'experiments'
  | 'filterModels'
  | 'filterProducts'
  | 'filterProductsOnMobile'
  | 'focusedProductIndex'
  | 'getCategoryProducts'
  | 'handleAddToCart'
  | 'handleMobileSortClick'
  | 'handlePagination'
  | 'handleProductItemClick'
  | 'hasMoreProductsToLoad'
  | 'hasSelectedFilters'
  | 'isAutoGrid'
  | 'isFirstPage'
  | 'isInteractive'
  | 'isLiveSiteMode'
  | 'isPreviewMode'
  | 'isMobile'
  | 'isRTL'
  | 'loadMoreProducts'
  | 'loadMoreType'
  | 'loading'
  | 'mainCollectionId'
  | 'numberOfSelectedFilterTypes'
  | 'openQuickView'
  | 'paginationMode'
  | 'productIdToProductPageUrlMap'
  | 'products'
  | 'selectedSort'
  | 'setProductsPerPage'
  | 'shouldShowAddToCartSuccessAnimation'
  | 'shouldShowClearFilters'
  | 'shouldShowMobileFiltersModal'
  | 'shouldShowSort'
  | 'showShowLightEmptyState'
  | 'sortProducts'
  | 'sortingOptions'
  | 'textsMap'
  | 'toggleFiltersModalVisibility'
  | 'totalProducts';

export interface IGalleryGlobalProps {
  globals?: Pick<IPropsInjectedByViewerScript & IGallerySantaProps, ProvidedGlobalPropNames> & {
    styleParams: IGalleryStyleParams;
  } & Pick<IHostProps, 'updateLayout' | 'dimensions' | 'appLoadBI'>;
}

export const galleryGlobalsStrategy = (props: IPropsInjectedByViewerScript & IGallerySantaProps) => {
  const {
    addedToCartSuccessfully,
    clearFilters,
    currentPage,
    experiments,
    filterModels,
    filterProducts,
    filterProductsOnMobile,
    focusedProductIndex,
    getCategoryProducts,
    handleAddToCart,
    handleMobileSortClick,
    handlePagination,
    handleProductItemClick,
    hasMoreProductsToLoad,
    hasSelectedFilters,
    isAutoGrid,
    isFirstPage,
    isInteractive,
    isLiveSiteMode,
    isPreviewMode,
    isMobile,
    isRTL,
    loadMoreProducts,
    loadMoreType,
    loading,
    mainCollectionId,
    numberOfSelectedFilterTypes,
    openQuickView,
    paginationMode,
    productIdToProductPageUrlMap,
    products,
    selectedSort,
    setProductsPerPage,
    shouldShowAddToCartSuccessAnimation,
    shouldShowClearFilters,
    shouldShowMobileFiltersModal,
    shouldShowSort,
    showShowLightEmptyState,
    sortProducts,
    sortingOptions,
    style,
    textsMap,
    toggleFiltersModalVisibility,
    totalProducts,
    ...locals
  } = props;

  const {appLoadBI, dimensions, updateLayout} = props.host;
  return {
    globals: {
      addedToCartSuccessfully,
      appLoadBI,
      clearFilters,
      currentPage,
      dimensions,
      experiments,
      filterModels,
      filterProducts,
      filterProductsOnMobile,
      focusedProductIndex,
      getCategoryProducts,
      handleAddToCart,
      handleMobileSortClick,
      handlePagination,
      handleProductItemClick,
      hasMoreProductsToLoad,
      hasSelectedFilters,
      isAutoGrid,
      isFirstPage,
      isInteractive,
      isLiveSiteMode,
      isPreviewMode,
      isMobile,
      isRTL,
      loadMoreProducts,
      loadMoreType,
      loading,
      mainCollectionId,
      numberOfSelectedFilterTypes,
      openQuickView,
      paginationMode,
      productIdToProductPageUrlMap,
      products,
      selectedSort,
      setProductsPerPage,
      shouldShowAddToCartSuccessAnimation,
      shouldShowClearFilters,
      shouldShowMobileFiltersModal,
      shouldShowSort,
      showShowLightEmptyState,
      sortProducts,
      sortingOptions,
      styleParams: style.styleParams,
      textsMap,
      toggleFiltersModalVisibility,
      totalProducts,
      updateLayout,
    },
    locals,
  };
};
